import { Controller } from "@hotwired/stimulus"

// Manages the mobile event list visibility.
// Currently shows all events; can be extended for day filtering.
export default class extends Controller {
  static targets = ["eventItem", "eventListContainer"]

  connect() {
    this.showAllEvents()
  }

  showAllEvents() {
    if (!this.hasEventItemTarget) return

    this.eventItemTargets.forEach(item => {
      item.style.display = ""
    })

    if (this.hasEventListContainerTarget) {
      this.eventListContainerTarget.style.display = ""
    }
  }
}
